import { axiosApiService } from '../axios';


const InventoryListAPIs = {
  InventoryListGet: async function ({ page = 1, pageSize = 10, search = '', category = '', group = '', tag = '', status = '', supervised = '' } = {}) {
    const response = await axiosApiService.get(`/admin_inventory_list/`, {
      params: {
        page: page,
        page_size: pageSize,
        search: search,
        category: category,
        group: group,
        tag: tag,
        status: status,
        supervised: supervised,
      },
    });
    return response.data;
  },

  AddInventory: async function (values, token) {
    try {
      const response = await axiosApiService.post(
        `/admin_inventory_list/`,
        values
      );
      return response;
    } catch (error) {
      console.error('Error adding Equipment:', error);
      // You can choose to return an error response or throw an error
      throw error;
    }
  },
};
export default InventoryListAPIs;
